export const INVESTOR_LOGIN_FORM_NAME = 'investorLoginForm';
